import { ChangeEvent } from 'react';
import { TextField } from '@mui/material';

interface CodeStepProps {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  disabled: boolean;
  label: string;
}

export function CodeStep({
  value,
  onChange,
  error,
  disabled,
  label,
}: CodeStepProps) {
  return (
    <TextField
      value={value}
      onChange={onChange}
      label={label}
      error={Boolean(error)}
      helperText={error ?? ' '}
      disabled={disabled}
      slotProps={{ htmlInput: { maxLength: 6 } }}
      fullWidth
    />
  );
}
